<template>
  <div class="wrapper">
    <div class="fixedCotanier">
      <div class="search-t">
        <div class="search-c">
          <img class="search" src="../../assets/images/search/search.svg" alt @click="search">
          <input type="search" placeholder="请输入商品或品牌名称" v-model="searchinp" @keyup.13="search">
          <img class="close" src="../../assets/images/search/close.svg" alt="" @click="returnHistory" v-show="pageState==1">
        </div>
        <div class="return" v-if="pageState==0" @click="returnGo">取消</div>
        <div class="return" v-if="pageState==1&&returnValue" @click="changeStyle">
          <img :src="require(`../../assets/images/search/change${style}.svg`)" alt="">
        </div>
      </div>
    </div>
    <div class="historyPage" v-if="pageState==0">
       <div class="item" v-if="keys.length > 0">
         <div class="title"><span>大家都在搜</span></div>
         <div class="list">
           <div class="key" v-for="item in keys" :key="item.nbr" @click="clickSearch(item.label)"><span>{{item.label}}</span></div>
         </div>
       </div>
       <div class="item" v-if="history.length > 0">
         <div class="title">
           <span>搜索历史</span>
           <img @click="historyShow=true" src="./../../assets/images/icon_delete.svg" alt="">
          </div>
         <div class="list">
           <div class="key" v-for="(item, index) in history" :key="index" @click="clickSearch(item)"><span class="line1Text">{{item}}</span></div>
         </div>
       </div>
    </div>
    <div class="searchPage" v-if="pageState==1">
      <div class="searchlist-t" v-show="list.length > 0">
        <div class="searchlist-tl" @click="sort(1)" :class="currentindex==1?'active':''"><span>默认</span></div>
        <div class="searchlist-tl" @click="sort(2)" :class="currentindex==2?'active':''"><span>最新</span></div>
        <!-- <div class="searchlist-tl" @click="sort(3)" :class="currentindex==3?'active':''">
          <span>销量</span>
          <img src="../../assets/images/search/icon1.svg" alt v-if="currentindex!=3">
          <img src="../../assets/images/search/icon2.svg" alt v-if="currentindex==3&&sortOrder=='2'">
          <img src="../../assets/images/search/icon3.svg" alt v-if="currentindex==3&&sortOrder=='1'">
        </div> -->
        <div class="searchlist-tl" @click="sort(4)" :class="currentindex==4?'active':''">
          <span>价格</span>
          <img src="../../assets/images/search/icon1.svg" alt v-if="currentindex!=4">
          <img src="../../assets/images/search/icon2.svg" alt v-if="currentindex==4&&sortOrder=='2'">
          <img src="../../assets/images/search/icon3.svg" alt v-if="currentindex==4&&sortOrder=='1'">
        </div>
     </div>
     <!--参照物-->
     <div id="czwitem1"></div>
     <div id="czwitem2"></div>
     <div class="search">
      <div class="searchlist">
        <van-list class="scroll" id="scroll" v-model="loading" :finished="finished" @load="loadMore" :offset="20">
            <div :class="style==1 ?'tabbox':'tabbox1'" v-if="list.length!=0">
              <div
                class="item"
                v-for="(item,index) in list"
                :key="index"
                @click="golistdetail(item.nbr, item.rule_type)"
              >
              <div  :class="style==1 ?'left':'top'">
                <img :src="style==1 ?item.commodity_logo + `${imgCrop}resize,w_200`:item.commodity_logo + `${imgCrop}resize,w_400`" alt="">
                <div class="noNum" v-if="item.quantity==='0'">
                  <img v-lazy="require('../../assets/images/noNum.png')" alt>
                </div>
              </div>
              <div class="right" v-if="style==1">
                <div class="titletop">
                  <div class="title">{{item.commodity_name}}</div>
                  <div class="titlebottom">
                    <div class="coupon" v-if="item.is_use_coupon == 1"><span>可使用优惠券</span></div> 
                    <img v-if="item.start_state==0" src="../../assets/images/beSale.png" alt="">
                  </div>
                  <div>
                   <div class="commoditySummary sigle-h" :style="item.commodity_summary?{background:'#FFF0B0'}:{background:'transparent'}">{{item.commodity_summary}}</div>
                  </div>
                  <div>
                   <div  v-if="item.is_sales_show=='1'" class="commoditySummarySales sigle-h">已抢{{item.show_sales_num}}件</div>
                   <div v-else class="commoditySummarySales sigle-h" style="background: none;"> </div>
                  </div> 
                </div>
                <div class="bottom">
                  <div style="marginBottom:.06rem">
                    <span style="fontWeight:bold">￥</span>
                      <span class="price" v-if="item.rule_type=='1'">{{roleText.toLocaleLowerCase()=='sell'&&item.show_price?item.show_price:item[`min_${roleText.toLocaleLowerCase()}_price`]}}</span>
                      <span class="price" v-if="item.rule_type=='2'">{{newRoleText.toLocaleLowerCase()=='sell'&&item.show_price?item.show_price:item[`min_${newRoleText.toLocaleLowerCase()}_price`]}}</span>
                      <!-- <span class="red" v-if="parseFloat((item[`min_sell_price`]-item[`min_${roleText.toLocaleLowerCase()}_price`]).toFixed(2)) != 0">
                        /
                        <span style="fontWeight:bold">赚￥{{parseFloat((item[`min_sell_price`]-item[`min_${roleText.toLocaleLowerCase()}_price`]).toFixed(2))}}</span>
                      </span> -->
                  </div>
                  <div>
                    <span class="oldPrice">￥{{item.old_price}}</span>
                  </div>
                  <img @click.stop="showSpec(item.nbr)" src="../../assets/images/search/cart.svg" alt="">
                </div>
              </div>
              <div class="bottomArea" v-else>
                <img v-if="item.start_state==0" class="beSale" src="../../assets/images/beSale.png" alt="">
                <div>
                  <div class="title">{{item.commodity_name}}</div>
                  <div class="coupon" v-if="item.is_use_coupon == 1"><span>可使用优惠券</span></div>

                  <div>
                   <div class="commoditySummary sigle-h" :style="item.commodity_summary?{background:'#FFF0B0'}:{background:'transparent'}">{{item.commodity_summary}}</div>
                  </div>
                  <div>
                    <div v-if="item.is_sales_show=='1'" class="commoditySummarySales sigle-h">已抢{{item.show_sales_num}}件</div>
                    <div v-else class="commoditySummarySales sigle-h" style="background: none;"> </div>
                  </div>
                </div>
                <div class="bottom">
                  <div>
                    <span style="fontWeight:bold">￥</span>
                    <span class="price" v-if="item.rule_type=='1'">{{(roleText.toLocaleLowerCase())=='sell'&&item.show_price?item.show_price:item[`min_${roleText.toLocaleLowerCase()}_price`]}}</span>
                    <span class="price" v-if="item.rule_type=='2'">{{(newRoleText.toLocaleLowerCase())=='sell'&&item.show_price?item.show_price:item[`min_${newRoleText.toLocaleLowerCase()}_price`]}}</span>
                    <!-- <span class="red" v-if="parseFloat((item[`min_sell_price`]-item[`min_${roleText.toLocaleLowerCase()}_price`]).toFixed(2)) != 0">
                      /
                    <span style="fontWeight:bold">赚￥{{parseFloat((item[`min_sell_price`]-item[`min_${roleText.toLocaleLowerCase()}_price`]).toFixed(2))}}</span>
                    </span> -->
                  </div>
                  <span class="oldPrice">￥{{item.old_price}}</span>
                </div>
                <img @click.stop="showSpec(item.nbr)" src="../../assets/images/search/cart.svg" alt="">
             </div>
            </div>
            <div class="nomore" v-show="finished==true && list.length != 0">没有更多了^v^</div>
          </div>
          <div class="noData" v-if="list.length==0&&noData">
           <!-- <img src="../../assets/images/icon_searchwu.svg" alt> -->
           <div>抱歉咯，没找到“ <span class="line1Text">{{searchValue}}</span> ”的搜索结果</div>
         </div>
        </van-list>
        
      </div>
     </div>
    </div>
    <!-- 规格弹窗 -->
    <div class="guige-popup" v-show="specShow">
      <van-popup v-model="specShow" position="bottom" :overlay="true" class="guigepopup">
        <!--<div class="guige-popupbox">-->
        <div class="guige-popupt">
          <div class="guige-popuptl">
            <div class="guige-popuptll">
              <img
                @click="showImage(assessmentDetail.inventoryLogo)"
                v-if="assessmentDetail.inventoryLogo"
                :src="assessmentDetail.inventoryLogo + `${imgCrop}resize,w_300`"
                alt
              />
              <img
                @click="showImage(goods_detail.commodityLogo)"
                v-else
                :src="goods_detail.commodityLogo+`${imgCrop}resize,w_300`"
                alt
              />
            </div>
            <div class="guige-popuptlr">
              <p v-if="assessmentDetail[`${roleText.toLocaleLowerCase()}Price`]">￥{{assessmentDetail[`${goods_detail.ruleType=='1'?roleText.toLocaleLowerCase():newRoleText.toLocaleLowerCase()}Price`]}}</p>
              <p v-else>￥{{goods_detail[`min${goods_detail.ruleType=='1'?roleText:newRoleText}Price`]}}</p>
              <p v-if="goods_detail.isQuantityShow==1&&assessmentDetail.quantity">库存：{{assessmentDetail.quantity}}</p>
              <p v-else-if="goods_detail.isQuantityShow==1">库存：{{quantity}}</p>
              <p v-else> </p>
              <p v-show="guigeCount==selectArr.length"><span>请选择</span></p>
              <p v-show="guigeCount!=selectArr.length"><span>已选：</span><span class="grey">{{guige}}</span></p>
            </div>
          </div>
          <div class="guige-popuptr" @click="specShow = false;">
            <img src="../../assets/images/icon_close.svg" alt />
          </div>
        </div>
        <div class="guige-popupc-wrap">
          <div class="guige-popupc" v-for="(item,n) in propertyListJson" :key="n">
            <div class="guige-popupct">{{item.name}}</div>
            <div class="guige-popupcc">
              <div
                class="guige-popupccm"
                v-for="(items,index) in item.children"
                :key="index"
                v-on:click="specificationBtn(item.name,items.name,items.quantity)"
                v-bind:class="items.quantity == 0?'nostock':
                [JSON.stringify(selectArr).indexOf(JSON.stringify({key:item.name,value:items.name}))!=-1?'productActive':'']"
              ><span>{{items.name}}</span></div>
              <!--noneActive-->
            </div>
          </div>
        </div>
        <div class="guige-popupn">
          <div class="guige-popupnl">
            数量
            <span v-if="goods_detail.limitQuantity>0">(每个ID限购{{goods_detail.limitQuantity}}件)</span>
          </div>
          <div class="guige-popupnr">
            <span :style="{'color':'#999'}" v-if="quantity==0">-</span>
            <span @click="changeNum(-assessmentDetail.addStep)" :style="{'color':(lowPriceStyle?'#999':'')}" v-else>-</span>
            <input :style="{'background':'#fff'}" type="number" v-model="num"  @blur="blurChange" v-if="quantity==0" disabled/>
            <input type="number" v-model="num" @blur="blurChange" v-else />
            <span  :style="{'color':'#999'}" v-if="quantity==0">+</span>
            <span @click="changeNum(assessmentDetail.addStep)" :style="{'color':(highPriceStyle?'#999':'')}" v-else>+</span>
          </div>
        </div>
        <div class="guige-popupnb">
          <div class="guige-popupnbl" @click="gocart">确定</div>
        </div>
        <!--</div>-->
      </van-popup>
    </div>
    <!--删除历史记录-->
    <van-popup class="closepopup" v-model="historyShow" :close-on-click-overlay="false">
      <van-row class="popup">
        <van-row class="content" type="flex" justify="center" align="center">您确定删除全部历史记录？</van-row>
        <van-row>
          <van-col class="cancel" @click.native="historyShow=false">取消</van-col>
          <van-col class="confirm" @click.native="deleteHistory">确定</van-col>
        </van-row>
      </van-row>
    </van-popup>
    <!--回到顶部-->
    <div class="toTop" @click="toTopAnimate" v-show="toTopShow">
      <img src="../../assets/images/index/top.svg" />
    </div>
  </div>
</template>

<script>
import weChatShareApi from "../../assets/js/weChatShare";
export default {
  components: {},
  props: {},
  mixins: [weChatShareApi],
  data() {
    return {
      searchinp: "", //
      list: "", //商品列表

      currentindex: "1", //当前下标
      sortType: "0",
      sortOrder: "1",

      searchValue:'',
      loading: false, //上拉加载
      finished: false, //加载完成
      pageIndex: 0,
      numPerPage: 10,
      roleText: "Sell",
      newRoleText:'Sell',
      keepAlive: true,
      scroll: 0,
      pageState:0,
      keys:[], // 大家都在搜
      history:JSON.parse(localStorage.getItem('searchHistory'))||[], // 历史记录
      historyShow:false,
      noData:false,
      specShow:false, // 规格弹窗
      assessmentDetail:{},
      propertyListJson: [], //规格属性
      goods_detail:{},
      quantity:0,
      guigeCount:0, // 规格未选择数
      quantityArr:[], // 为库存为0数组
      selectArr: [], //存放被选中的值
      guige: "请选择", //已选规格
      num: 1, //加减数量
      goodNbr:'', // 点击的商品nbr
      lowPriceStyle: true, // 加减价格样式
      highPriceStyle: false,
      style:2,
      returnValue:false,
      toTopShow:false,
      scrollNum:0,
      isLogin:0,
    };
  },
  watch: {
    $route(to, from) {
      if (
        from.path == "/information" ||
        from.path == "/placeorder" ||
        from.path == "/recommend"||
        from.path == "/index"
      ) {
        this.keepAlive = true;
      } else {
        this.keepAlive = false;
      }
    },
  },
  computed: {
  },
  methods: {
    checkOption(){
      if(!(this.userInfo&&this.userInfo.nbr)){
        let option = {
          title: '我的店铺',
          desc: "欢迎光临我的店铺",
          link: location.origin,
          images: this.cdnImgPath + '/images/default/wx_head_default.jpg',
        }
        this.weChatShare(option);
        this.isLogin = 0;
        this.roleText = 'Sell';
        this.newRoleText = 'Sell';
      }else{
        let option = {
        title: '有米@'+this.userInfo.name + "的店铺",
        desc: "欢迎光临我的店铺",
        link: location.origin + "/?supNbr=" + this.userInfo.nbr,
        images: this.userInfo.imgUrl
        };
        this.weChatShare(option);
        this.isLogin = 1;
      }
    },
    showImage(img){
     wx.previewImage({
       current:img,
       urls:[img]
     })
    },
    changeNum(value) {
      let num = this.num + value;
      if(/^\d+$/g.test(num)){
        this.num = num;
        this.checkNum();
      }
    },
    changeStyle(){
      let style = this.style;
      let element1 = document.getElementById('czwitem1');
      let element2 = document.getElementById('czwitem2');
      let scrollTop = document.getElementById('scroll').scrollTop;
      if(style == 1){
        let index = Math.floor(scrollTop/element1.offsetHeight);
        let top = index*element2.offsetHeight;
        this.style = 2;
        setTimeout(()=>{
          document.getElementById('scroll').scrollTop = top;
        },0)
      }else{
        let index = Math.floor(scrollTop/element2.offsetHeight);
        let top = index*element1.offsetHeight
        this.style = 1;
        setTimeout(()=>{
          document.getElementById('scroll').scrollTop = top;
        },0)
      }
      //this.search(true);
    },
    gocart() {
      let userNbr = this.userInfo.nbr;
      if(this.quantity == 0){
        return this.$toast({
          message: '该商品库存为0',
          duration: 2000
        });
      }
      if(this.guigeCount==0){
        this.$commonPost({
          jydm: "flow_10000",
          flow_10000: {
            sub_flow: "flow_30001",
            user_nbr: userNbr,
            commodity_nbr: this.goodNbr,
            inventory_nbr: this.assessmentDetail.nbr,
            quantity: this.num
          }
        })
          .then(response => {
            this.specShow = false;
            this.$toast({
              message: "已加入购物车！",
              duration: 2000
            });
          })
          .catch(err => {
            this.$toast({
              message: err.message,
              duration: 2000
            });
          });
      }else{
        this.$toast({
          message: '请选择规格',
          duration: 2000
        });
      }
    },
    specificationBtn: function(key, value, num) {
      let text = "";
      let selectArr = this.selectArr;
      if(num == 0 ){
        return this.$toast({
            message: "该规格库存为0",
            duration: 2000
          });
      }
      selectArr.map((item, index) => {
        if (item.key == key) {
          if(item.value == value){
            selectArr[index].value = '';
          }else{
            selectArr[index].value = value;
          }
        }
      });
      let dIndex = 0;
      for (let i=0;i<selectArr.length;i++) {
        if(selectArr[i].value != ''){
          if (i == dIndex) {
            text = selectArr[i].value;
          } else {
            text += "," + selectArr[i].value;
          }
        }else{
          dIndex += 1;
        }
      }
      let assessmentDetail = this.assessmentDetail;
      let goods_detail = this.goods_detail;
      let propertyListJson = this.propertyListJson;
      let checkPriceChange = this.checkPriceChange;
      let count = 0;
      selectArr.map(item=>{
        if(item.value == ''||!item.value){
          count += 1;
        }
      })
       let inventoryList = []
      if(count == selectArr.length){
        assessmentDetail.minimumSellNum = 1;
        assessmentDetail.addStep = 1;
        assessmentDetail.inventoryLogo = goods_detail.commodityLogo;
        assessmentDetail.directorPrice = checkPriceChange(goods_detail.minDirectorPrice,goods_detail.maxDirectorPrice);
        assessmentDetail.agentPrice = checkPriceChange(goods_detail.minAgentPrice,goods_detail.maxAgentPrice);
        assessmentDetail.sellPrice = checkPriceChange(goods_detail.minSellPrice,goods_detail.maxSellPrice) ;
        assessmentDetail.quantity = this.quantity;
        this.assessmentDetail = assessmentDetail;
      } else if( count > 0 ){
        let propertyList = this.goods_detail.commodityInventoryList
        let propertyArr = [];
        for (let a = 0;a< selectArr.length;a++) {
          if(selectArr[a].value){
            let aItem = {
              propertyName: selectArr[a].key,
              propertyValue: selectArr[a].value
            };
            propertyArr.push(aItem);
          } 
        }
       for (let b = 0;b< propertyList.length;b++) {
          let bItem = propertyList[b].propertyListJson;
          let count = 0;
          for (let c = 0;c< propertyArr.length;c++) {
            if (
              JSON.stringify(bItem).indexOf(JSON.stringify(propertyArr[c])) != -1
            ) {
              count += 1;
            }
          }
          if (count == propertyArr.length) {
            inventoryList.push(propertyList[b]);
          }
        }
        this.assessmentDetail = JSON.parse(JSON.stringify(inventoryList[0]))
      }else{
        this.checkItem(selectArr);
      }
      this.thisCheckNoClick(selectArr);
      this.guigeCount = count;
      this.guige = text;
      this.selectArr = selectArr;
    },
    checkPriceChange(a,b){
      if(a==b){
        return a;
      }else{
        return a + '-' + b;
      }
    },
    thisCheckNoClick(selectArr){
      let quantityArr = this.quantityArr;
      let propertyListJson = this.propertyListJson;
      propertyListJson.map((json,index1)=>{
        json.children.map((child,index2)=>{
          let arr = [];
          arr.length = propertyListJson.length;
          arr[index1] = {
            propertyName:json.name,
            propertyValue:child.name,
          }
          selectArr.map((select,index3)=>{
            if(index3 != index1){
              arr[index3] = {
                propertyName:select.key,
                propertyValue:select.value,
              }
            }
          });
          if( JSON.stringify(quantityArr).indexOf(JSON.stringify(arr)) > 0 ){
            child.quantity = 0;
          }else{
            child.quantity = 1;
          }
        })
      })
      this.propertyListJson = propertyListJson;
    },
    checkItem: function(selectArr) {
      let propertyArr = [];
      let propertyList = this.goods_detail.commodityInventoryList;
      for (let a=0;a<selectArr.length;a++) {
          let aItem = {
            propertyName: selectArr[a].key,
            propertyValue: selectArr[a].value
          };
          propertyArr.push(aItem);
        }
        for (let b=0;b<propertyList.length;b++) {
          let bItem = propertyList[b].propertyListJson;
          let count = 0;
          for (let c=0;c<propertyArr.length;c++) {
            if (
              JSON.stringify(bItem).indexOf(JSON.stringify(propertyArr[c])) != -1
            ) {
              count += 1;
            }
          }
          if (count == bItem.length) {
            this.assessmentDetail = JSON.parse(JSON.stringify(propertyList[b]));
            this.num = this.assessmentDetail.minimumSellNum;
          }
        }
      this.$forceUpdate(); //重绘
    },
    checkNoClick: function() {
      let propertyList = this.goods_detail.commodityInventoryList;
      let quantityArr = [];
      for(let i=0;i<propertyList.length;i++){
        if(propertyList[i].quantity == 0){
          let propertyComplete = propertyList[i].propertyListJson;
          quantityArr.push(propertyComplete);
        }
      }
      this.quantityArr = quantityArr;
    },
    blurChange() {
      this.checkNum()
      window.scrollTo(0, 0);
    },
    checkNum() {
      let value = this.num;
      let assessmentDetail = this.assessmentDetail;
      let limitQuantity = this.goods_detail.limitQuantity
      this.highPriceStyle = false;
      this.lowPriceStyle = false;
      if(JSON.stringify(assessmentDetail)=='{}'){
        assessmentDetail={
          minimumSellNum:1,
          addStep:1,
          quantity:this.goods_detail.totalQuantity
        }
      }
      if(!value||value==''||value <= assessmentDetail.minimumSellNum){
        value = assessmentDetail.minimumSellNum;
        this.lowPriceStyle = true;
      }
      if(limitQuantity > 0){
        if(value >= limitQuantity){
          let low = (limitQuantity - assessmentDetail.minimumSellNum) % assessmentDetail.addStep;
          value = limitQuantity - low;
          this.highPriceStyle = true;
        }else{
          value = value - ((value-assessmentDetail.minimumSellNum)%assessmentDetail.addStep);
        }
      }
      else{
        if(value > assessmentDetail.quantity){
          let low = (assessmentDetail.quantity - assessmentDetail.minimumSellNum) % assessmentDetail.addStep;
          value = assessmentDetail.quantity - low;
          this.highPriceStyle = true;
        }else{
          value = value - ((value-assessmentDetail.minimumSellNum)%assessmentDetail.addStep);
        }
        console.log(value);
      }
      this.num = parseInt(value);
    },
    returnHistory(){
      document.title = "搜索";
      this.searchinp = '';
      this.searchValue = '';
      this.pageState = 0;
      this.pageIndex = 0;
      this.list = [];
      this.style = 1;
    },
    returnGo(){
      history.go(-1);
    },
    deleteHistory(){
      this.history = [];
      this.historyShow = false;
      localStorage.removeItem('searchHistory');
      this.$toast({
        message: '清除成功',
        duration: 2000
      });
    },
    golistdetail(nbr,type) {
      this.$router.push({
        path: type=='1'?"/listdetail":"/sourceListdetail",
        query: { nbr: nbr, supNbr:this.userInfo.nbr }
      });
    },
    clickSearch(value){
      this.searchinp = value;
      this.search();
    },
    search(bool) {
      document.title = "搜索结果";
      if(typeof bool == 'undefined'||typeof bool == 'object'){
        this.sortType = "0";
        this.sortOrder = "1";
        this.currentindex = 1;
      }
      this.pageIndex = 0;
      this.noData = false;
      this.returnValue = false;
      this.finished = false;
      this.list = [];
      this.getListData([]);
      this.pageState = 1;
      let searchinp = this.ruleText(this.searchinp);
      this.searchValue = searchinp;
      if(searchinp != ''){
        let searchHistory = this.history;
        searchHistory.map((item,index) => {
          if(searchinp == item){
            searchHistory.splice(index,1);
          }
        })
        searchHistory.unshift(searchinp);
        localStorage.setItem('searchHistory',JSON.stringify(searchHistory));
      }
    },
    ruleText(text){
      return text.replace(/(^\s*)|(\s*$)/g, "");
    },
    getCommodityNum(nbr){
      this.$commonPost({
      jydm: "flow_70059",
      flow_70059: {
        nbr: nbr,
        wechat_version: 1
      }
    })
      .then(response => {
        this.quantity = response.commodity.quantity;
      })
      .catch(err => {
        this.$toast({
          message: err.message,
          duration: 2000
        });
      });
    },
    showSpec(nbr){
      this.goodNbr = nbr;
      this.guigeCount = 0;
      let toast = this.$toast.loading({
          mask: false,
          duration: 0
      });
      this.assessmentDetail = {};
      this.$post("/api/customer/queryCommodityDetail", {
        commodityNbr: nbr
      })
      .then(res => {
        let arr = [];
        let data = res.object.resp.commodity;
        let text = "";
        let propertyArr = [];
        if (res.code == "200") {
          let resp = res.object.resp;
          if (resp.resp_code == "0" && resp.resp_result == "0") {
            if (data.commodityLogoList) {
              arr = data.commodityLogoList.split(",");
            }
            this.getCommodityNum(data.nbr)
            data.endTime = data.endTime.slice(0, 19);
            this.goods_detail = data;
            this.images = arr;
            this.propertyListJson = data.propertyJson;
            let commodityInventoryList = data.commodityInventoryList;
            if(commodityInventoryList.length==1&&commodityInventoryList[0].quantity>0){
              commodityInventoryList[0].propertyListJson.map((item,j)=>{
                if (j == 0) {
                  text = item.propertyValue;
                } else {
                  text += "," + item.propertyValue;
                }
                let obj = {
                  key: item.propertyName,
                  value: item.propertyValue
                };
                propertyArr.push(obj);
              })
              this.guigeCount = 0;
            }else{
              this.guigeCount = data.propertyJson.length;
              data.propertyJson.map((item,j)=>{
                let obj = {
                  key: item.name,
                  value: ''
                };
                propertyArr.push(obj);
              })
            }
            this.guige = text;
            this.selectArr = propertyArr;
            this.checkItem(propertyArr);
            this.checkNoClick();
            this.thisCheckNoClick(propertyArr);
            toast.clear();
            this.specShow = true;
          } else {
            this.$toast({
              message: resp.resp_msg,
              duration: 2000
            });
          }
        } else {
          this.$toast({
            message: resp.message,
            duration: 2000
          });
        }
      })
      .catch(err => {
        this.$toast({
          message: err.message,
          duration: 2000
        });
      });

    },
    sort(index) {
      this.finished = false;
      let currentindex = this.currentindex;
      let sortType = this.sortType,
      sortOrder = this.sortOrder;
      switch (index) {
        case 1:
          sortType = "0";
          sortOrder = "1";
          break;
        case 2:
          sortType = "3";
          sortOrder = "2";
          break;
        case 3:
          sortType = "2";
          if (currentindex != index) {
            sortOrder = "2";
          } else {
            sortOrder = sortOrder == "2" ? "1" : "2";
          }
          break;
        case 4:
          sortType = "1";
          if (currentindex != index) {
            sortOrder = "1";
          } else {
            sortOrder = sortOrder == "1" ? "2" : "1";
          }
          break;
        default:
          sortType = "0";
          sortOrder = "1";
      }

      this.currentindex = index;
      this.sortType = sortType;
      this.sortOrder = sortOrder;
      this.pageIndex = 0;
      this.list = [];
      this.getListData([]);
    },
    loadMore() {
      if (this.finished) {
        return false;
      }
      this.loading = true;
      this.pageIndex++;
      this.getListData(this.list);
    },
    getListData(oldList) {
      let searchValue = this.searchinp;
      this.loading = true;
      //搜索
      this.$commonPost({
        jydm: "flow_70001",
        flow_70001: {
          commodity_name: searchValue,
          sort_type: this.sortType,
          sort_order: this.sortOrder,
          page_index: this.pageIndex * this.numPerPage,
          num_per_page: this.numPerPage
        }
      })
        .then(response => {
          let arr = [];
          if (response.commodityList && response.commodityList.commodity) {
            if (response.commodityList.commodity.length > 0) {
              arr = response.commodityList.commodity;
            } else {
              arr.push(response.commodityList.commodity);
            }
            this.noData = false;
            this.returnValue = true;
          }else{
            this.noData = true;
            this.returnValue = false;
          }
          this.list = oldList.concat(arr);
          this.loading = false;
          if (arr.length < this.numPerPage) {
            this.finished = true;
          }
        })
        .catch(err => {
          this.noData = true;
          this.returnValue = false;
          this.$toast({
            message: err.message,
            duration: 2000
          });
        });
    },
    handleScroll(){
      // 设备/屏幕高度
      let scrollTop = document.getElementById('scroll').scrollTop;
      if(scrollTop > 50){
        this.toTopShow = true;
      }else{
        this.toTopShow = false;
      }
    },
    // 回到顶部动画
    toTopAnimate(){
      document.getElementById('scroll').scrollTop = 0;
    },
    getUserInfo(){
      this.$commonPost({
        jydm: "flow_10003",
        flow_10003: {
          user_nbr: this.userInfo.nbr
        }
      })
        .then(response => {
          if (response.role == 0||response.role == 1) {
            this.roleText = "Sell";
          } else if (response.role == 2) {
            this.roleText = "Agent";
          } else if (response.role == 3) {
            this.roleText = "Director";
          }
          if (response.new_role == 0 || response.new_role == 1) {
            this.newRoleText = "Sell";
          } else if (response.new_role == 2) {
            this.newRoleText = "Agent";
          } else if (response.new_role == 3) {
            this.newRoleText = "Director";
          }
          //this.roleText = "sell";
        })
        .catch(err => {
          this.$toast({
            message: err.message,
            duration: 2000
          });
        });
    },
  },
  created() {
  },
  mounted() {
  },
  // 被缓存时任执行
  activated() {
    window.addEventListener('scroll', this.handleScroll, true);
    document.title = "搜索";
    this.checkOption();

    if (!this.keepAlive) {
      //将高度滚动到原来离开页面的高度
      document.getElementById("scroll").scrollTop = this.scroll;
      return false;
    } else {
      //this.searchinp = this.$route.query.searchinp;
      this.pageIndex = 0;
      this.noData = false;
      this.list = [];
      this.pageState = 0;
      // 用户的基本信息(身份)
      if(this.userInfo&&this.userInfo.nbr){
        this.getUserInfo();
      }
        // 关键词
      this.$commonPost({
        jydm: "flow_70055",
        flow_70055: {}
      })
        .then(response => {
          let arr = [];
          if(response.resp_code==0&&response.resp_result==0){
            if(response.label){
             if(response.label.length>1){
               arr = response.label;
             }else{
               arr.push(response.label);
             }
            }
          }
          this.keys = arr;
        })
        .catch(err => {
          this.$toast({
            message: err.message,
            duration: 2000
          });
        });
    }
  },
  beforeRouteLeave(to, from, next) {
    this.searchinp = '';
    if(document.getElementById("scroll")){
      this.scroll = document.getElementById("scroll").scrollTop;
    }
    window.removeEventListener('scroll', this.handleScroll,true);
    next();
  }
};
</script>
<style scoped lang='stylus'></style>
<style scoped lang='less'>
#czwitem1{
  position: absolute;
  z-index: -999;
  height: 5.6rem;
}
#czwitem2{
  position: absolute;
  z-index: -999;
  height: 6.095rem;
}
.toTop{
  position: fixed;
  right: .2rem;
  z-index: 999;
  bottom: 2rem;
  width: .8rem;
  height: 0.8rem;
  background: rgba(51,51,51,0.5);
  border-radius:50%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.toTop img{
  width: 0.4rem;
  height: 0.4rem;
}
.guige-popup {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 10;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: flex-end;
  width: 100%;
}
.guige-popupbox {
  margin-top: calc(100vh - 9.48rem);
  background: #ffffff;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}
.guige-popupt {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin: 0 0.24rem;
  margin-top: 0.24rem;
}

.guige-popuptl {
  display: flex;
  flex-direction: row;
}

.guige-popuptlr {
  margin-left: 0.24rem;
}

.guige-popuptlr p:nth-of-type(1) {
  color: #E52B25;
  font-size: 0.4rem;
  margin-top: 0.1rem;
}

.guige-popuptlr p:nth-of-type(2) {
  font-size: 0.24rem;
  margin-top: 0.1rem;
  line-height: 0.35rem;
  color: #999;
}

.guige-popuptlr p:nth-of-type(3) {
  font-size: 0.24rem;
  margin-top: 0.1rem;
  width: 4.72rem;
  line-height: 0.35rem;
  display: flex;
  justify-content: flex-start;
  span{
    height:100%;
  }
}
.guige-popuptlr p:nth-of-type(4) {
  font-size: 0.24rem;
  margin-top: 0.1rem;
  width: 4.72rem;
  line-height: 0.35rem;
  display: flex;
  justify-content: flex-start;
  span{
    height:100%;
  }
}
.guige-popuptr{
  position: absolute;
  top: .24rem;
  right:.24rem;
  img{
    width: 0.4rem;
  }
}
.guige-popuptr img{
  width:0.4rem;
  height:0.4rem;
}
.guige-popuptll img {
  width: 2rem;
  height: 2rem;
  border-radius: 0.08rem;
}

.guige-popupc-wrap {
  width: 100%;
  margin-top: 0.2rem;
  height: 4.8rem;
  overflow-y: auto;
}

.guige-popupct {
  font-size: 0.28rem;
  margin-left: 0.24rem;
  margin-top: 0.4rem;
}

.guige-popupcc {
  width: calc(100% - .24rem);
  margin-left: .12rem;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}

.guige-popupccm {
  padding: 0.05rem 0.25rem;
  box-sizing: border-box;
  background: #fff;
  border-radius: 0.5rem;
  margin-right: 0.12rem;
  margin-left: 0.12rem;
  margin-top: 0.24rem;
  border: 1px solid #999;
  font-size: 0.24rem;
  line-height: .34rem;
  span{
    display: inline-block;
    line-height: 0.34rem;
    word-break:break-all;
  };
}

.guige-popupcc .productActive {
  background-color: #E52B25 !important;
  color: #fff !important;
  border: 1px solid #E52B25 !important;
  box-sizing: border-box;
}

.guige-popupcc .noneActive {
  background-color: #ccc !important;
  opacity: 0.4 !important;
  color: #000 !important;
  pointer-events: none !important;
}

.guige-popupn {
  margin: 0 0.24rem .28rem;
  height: 1.08rem;
  line-height: 1.08rem;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  background: #fff;
  position: relative;
  border-top: 1px solid #eee;
  border-bottom: 1px solid #eee;
  box-sizing:border-box;
  align-items: center;
}

.guige-popupnb {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  /*position: absolute;*/
  /*bottom: 0;*/
  /*left: 0;*/
  margin-top: 0.12rem;
}
.guigepopup{
  border-top-left-radius: .3rem;
  border-top-right-radius: .3rem;
}
.guige-popupnbl {
  width: 100%;
  text-align: center;
  line-height: 1.08rem;
  font-size: 0.3rem;
  color: #fff;
  background: #E52B25;
}

.guige-popupnbr {
  width: 3.8rem;
  text-align: center;
  line-height: 1.08rem;
  font-size: 0.3rem;
  color: #fff;
  background: #E52B25;
}
.guige-popupnbr-no {
  width: 3.8rem;
  text-align: center;
  line-height: 1.08rem;
  font-size: 0.3rem;
  color: #fff;
  background: #cccccc;
}
.guige-popupnl span {
  margin-left: 0.2rem;
  color: #999;
}

.guige-popupnr{
  border-radius:.29rem;
  border:1px solid #999;
  height: 0.6rem;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 2.2rem;
}

.guige-popupnr span {
  display: inline-block;
  width: 0.6rem;
  height: 0.58rem;
  text-align: center;
  line-height: 0.58rem;
  vertical-align: middle;
  border-right: none;
}

.guige-popupnr input {
  width: 1rem;
  line-height: 0.58rem;
  text-align: center;
  outline: 0;
  padding-top: 0.01rem;
  vertical-align: middle;
  border:none;
  border-radius:0;
  border-left:1px solid #999;
  border-right:1px solid #999;
  box-sizing:border-box;
}
.closepopup {
  border-radius: 0.18rem;
}
.popup {
  width: 6.14rem;
  height: 3.04rem;
  .content {
    height: 1.95rem;
    text-align: center;
    font-size: 0.28rem;
    color: #999999;
  }
  .cancel {
    height: 1.07rem;
    text-align: center;
    line-height: 1.07rem;
    width: 50%;
    background: #f5f5f5;
    font-size: 0.32rem;
    color: #333333;
    border-right: 1px solid #ebebeb;
  }
  .confirm {
    height: 1.07rem;
    text-align: center;
    line-height: 1.07rem;
    width: 50%;
    background: #f5f5f5;
    font-size: 0.32rem;
    color: #E52B25;
  }
}
.historyPage{
  padding-top: 1.18rem;
  overflow-x: hidden;
  height:100vh;
  box-sizing: border-box;
  .item{
    width: 100%;
    .title{
      width: 100%;
      height: .8rem;
      line-height: 0.8rem;
      box-sizing: border-box;
      padding-left: .24rem;
      padding-right: .24rem;
      margin-bottom: 0.2rem;
      display: flex;
      justify-content: space-between;
      align-items: center;
      span{
        font-size: .28rem;
        color: #333;
        font-weight: bold;
      }
      img{
        width: .3rem;
        height: 0.3rem;
      }
    }
    .list{
      width: 100%;
      max-height: 4.56rem;
      box-sizing: border-box;
      padding-left: 0.24rem;
      padding-bottom: .2rem;
      display: flex;
      justify-content: flex-start;
      flex-wrap: wrap;
      overflow: hidden;
      .key{
        padding: 0.1rem .2rem;
        background: #f7f7f7;
        border-radius: .04rem;
        display: inline-block;
        line-height: .28rem;
        margin-right: 0.2rem;
        margin-bottom: .2rem;
        span{
          font-size: .26rem;
        }
      }
    }
  }
}
.searchPage{
  position: fixed;
  top: 1.56rem;
  left: 0;
  width: 100%;
  .scroll{
    height: calc(100vh - 1.56rem);
    overflow-y: scroll;
    -webkit-overflow-scrolling:touch;
    width: 100%;
  }
  .scroll::-webkit-scrollbar {
     display: none;
  }
}
.fixedCotanier{
  position: fixed;
  top: 0;
  background: #fff;
  z-index: 9;
  width: 100%;
  box-shadow: 0 2px 18px 0 rgba(0,0,0,0.02);
}
.hide {
  display: none !important;
}
.noData {
  margin-top: .52rem;
}
.noData img {
  width: 2.8rem;
  height: 2.8rem;
}
.line1Text{
  max-width: 3rem;
  line-height: .3rem;
  overflow: hidden;
  text-overflow:ellipsis;
  white-space: nowrap;
  word-break: break-all;
  display: inline-block;
}
.noData div:nth-of-type(1) {
  font-size: .28rem;
  color: #333;
  line-height: 0.3rem;
  display: flex;
  justify-content: center;
  align-items: center;
}
.noData div:nth-of-type(2) {
  font-size: 0.32rem;
  color: #999;
  line-height: 0.5rem;
}
.active {
  font-weight: 700;
  color: #333 !important;
}
.wrapper {
  width: 100%;
}
.search-t {
  margin: .14rem auto .14rem;
  width: 7.02rem;
  height: 0.6rem;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.search-t .search-c{
  flex:1;
  background-color: #f9f9f9;
  border-radius: 0.3rem;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.search-t .return{
  color: #333;
  font-size: 0.28rem;
  margin-left: 0.24rem;
}
.search-t .return img{
  width: 0.4rem;
  height: 0.4rem;
}
.search-t .search {
  margin-left: 0.18rem;
  vertical-align: middle;
  width: 0.4rem;
  height: 0.4rem;
}
.search-t .close {
    margin-right: 0.18rem;
    vertical-align: middle;
    width: 0.36rem;
    height: 0.36rem;
}
.search-t input {
  flex: 1;
  display: inline-block;
  margin-left: 0.2rem;
  background: none;
  border: none;
  /* //   color: #f7f7f7; */
  line-height: 0.6rem;
  font-size: 0.28rem;
}
input[type="search"]::-webkit-search-cancel-button {
  -webkit-appearance: none;
}
.search-t input::-webkit-input-placeholder {
  color: #999;
}
.search-t input::-ms-input-placeholder {
  /* //由于我的IE刚好是IE9，支持不了placeholder，所以也测试不了(⊙﹏⊙)，有IE10以上的娃可以帮我试试 */
  color: #999;
}
.searchlist-t {
  position: fixed;
  top: .88rem;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  font-size: 0.28rem;
  z-index: 9;
  background: #fff;
  width: 100%;
  height: .68rem;
}
.nostock{
  background: #eeeeee !important;
  color: #b7b7b7 !important;
  border: 1px solid #eeeeee !important;
}
.searchlist-tl{
  flex:1;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #999;
  img{
    width: .14rem;
    height: .18rem;
    margin-left: .08rem;
  }
  span{
    line-height:.34rem;
    font-size: 0.24rem;
  }
}
.tabbox {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  .item{
    width: 100%;
    height: 3.4rem;
    padding:.2rem .24rem;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #eee;
    .left{
      position: relative;
      .noNum {
        position: absolute;
        display: flex;
        justify-content: center;
        align-items: center;
        top: 0;
        left: 0;
        background: rgba(51, 51, 51, 0.3);
        width: 100%;
        height: 2rem;
        border-radius: .08rem;
        img{
          width: 75%;
          height: 60%;
        }
      }
      img{
        width: 2.4rem;
        height: 2.4rem;
        border-radius: .08rem;
      }
    }
    .right{
      width: calc(100% - 2.6rem);
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      height: 100%;
      .commoditySummary{
        color: #FF3500;
        font-size: 0.2rem;
        font-weight: 500;
        margin: 0.12rem 0 0;
        background: #FFF0B0;
        padding: 0.04rem 0.1rem;
        border-radius: 0.04rem;
        display: inline-block;
        height: 0.26rem;
        max-width: 4.2rem;
        line-height: 1.5;
      }
      .commoditySummarySales{
        color: #0074FF;
        font-size: 0.2rem;
        font-weight: 500;
        margin: 0.12rem 0 0;
        background: #EEF7FF;
        padding: 0.04rem 0.1rem;
        border-radius: 0.04rem;
        display: inline-block;
        height: 0.26rem;
        max-width: 4.2rem;
        line-height: 1.5;
      }
      .title{
        width: 100%;
        font-size: .24rem;
        color: #333;
        line-height: .33rem;
        height: 0.66rem;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        word-break: break-all;
        white-space: normal;
      }
      .titlebottom{
        margin-top: .18rem;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        img{
          width: 1.16rem;
          height: 0.3rem;
        }
      }
      .coupon{
         width: 1.34rem;
         height: 0.3rem;
         line-height: 0.3rem;
         display: flex;
         justify-content: center;
         align-items: center;
         background: #FFF1F2;
         border-radius: .04rem;
         margin-right: .14rem;
         span{
           font-size: .18rem;
           color: #F53547;
           line-height: 0.3rem;
         }
      }
      .bottom{
        position: relative;
        font-size: 0.24rem;
        .red{
          color: #E52B25;
        }
        .price{
          font-size: .32rem;
          font-weight: bold;
        }
        .oldPrice{
          color: #999;
          text-decoration: line-through;
          margin-left: 0.03rem;
        }
        img{
          width: .5rem;
          height: .5rem;
          position: absolute;
          top: 50%;
          right: 0;
          transform: translateY(-50%);
        }
      }
    }
  }
}
.tabbox1{
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  .item{
    width: 3.42rem;
    height: 6.6rem;
    background: #FFFFFF;
    border: 1px solid #DDDDDD;
    box-sizing: border-box;
    border-radius: .16rem;
    overflow: hidden;
    display: inline-block;
    margin-top: .04rem;
    margin-left: .24rem;
     .commoditySummary{
        max-width: 3rem;
        color: #FF3500;
        font-size: 0.2rem;
        line-height: 1.5;
        height: 0.26rem;
        font-weight: 500;
        margin: 0.12rem 0 0;
        background: #FFF0B0;
        padding: 0.04rem 0.1rem;
        border-radius: 0.04rem;
        display: inline-block;
    }
    .commoditySummarySales{
        color: #0074FF;
        background: #EEF7FF;
        max-width: 3rem;
        font-size: 0.2rem;
        line-height: 1.5;
        height: 0.26rem;
        font-weight: 500;
        margin: 0.12rem 0 0;
        padding: 0.04rem 0.1rem;
        border-radius: 0.04rem;
        display: inline-block;
      }
    .top{
      width: 100%;
      height: 3.42rem;
      box-sizing: border-box;
      border-bottom: 1px solid #ddd;
      position: relative;
      overflow: hidden;
      .noNum {
        position: absolute;
        display: flex;
        justify-content: center;
        align-items: center;
        top: 0;
        left: 0;
        background: rgba(51, 51, 51, 0.3);
        width: 100%;
        height: 3.42rem;
        img{
          width: 75%;
          height: 60%;
        }
      }
      img{
        width: 100%;
        height: 3.42rem;
      }
    }
    .bottomArea{
      padding: .1rem;
      height: calc(100% - 3.42rem);
      box-sizing: border-box;
      position: relative;
      .beSale{
        width: 1.16rem;
        height: .3rem;
        position: absolute;
        top: -.15rem;
        left: 0.1rem;
      }
      .coupon{
         margin-top: .1rem;
         width: 1.34rem;
         height: 0.3rem;
         line-height: 0.3rem;
         display: flex;
         justify-content: center;
         align-items: center;
         background: #FFF1F2;
         border-radius: .04rem;
         span{
           font-size: .18rem;
           color: #F53547;
           line-height: 0.3rem;
         }
      }
      .title{
        font-size: .24rem;
        color: #333333;
        line-height: .32rem;
        margin-top: 0.12rem;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        word-break: break-all;
        white-space: normal;
        height: 0.62rem;
      }
      .bottom{
        position: absolute;
        bottom: .12rem;
        font-size: 0.24rem;
        color: #333;
        display: flex;
        flex-direction: column;
        .price{
          font-size: 0.3rem;
          font-weight: bold;
        }
        .oldPrice{
          color: #666;
          margin-left: 0.03rem;
          text-decoration: line-through;
          line-height: .34rem;
          margin-top: 0.03rem;
        }
        .red{
          color: #E52B25;
        }
      }
      img{
          position: absolute;
          width: 0.4rem;
          height: .36rem;
          right: .22rem;
          bottom: 0.22rem;
        }
      
    }
  }
}

.nomore {
  width: 100%;
  text-align: center;
  color: #999999;
  line-height: 1rem;
}
</style>



// WEBPACK FOOTER //
// src/components/index/searchlist.vue